import workspaceQuery from '../../../graphql/queries/product/ProductCategoryWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/product/ProductCategoryQuery.graphql';
import defaultQuery from '../../../graphql/queries/product/ProductCategoryDefault.graphql';
import mutationQuery from '../../../graphql/mutations/product/ProductCategoryMutation.graphql';
import listQuery from '../../../graphql/queries/product/ProductCategoryListQuery.graphql';
import fragment from '../../../graphql/fragments/product/ProductCategoryFragment.graphql';
import { Direction } from '../../schema/p4types';

const ProductCategory = {
  type: 'ProductCategory',
  title: 'Product Categories',
  formTitle: 'Product Category',
  formUrl: '/Products/Category/Details/',
  workspaceUrl: '/Products/Category/Treespace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  returnUrl: '/menu/Products',
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
    remoteFilter: true,
    preLoad: true,
    placeholder: 'Search categories',
    customVariables: () => {
      return {
        orderBy: 'name',
        orderDirection: Direction.Asc,
        first: 50,
      };
    },
  },
  fragment,
  screenReference: 'PRODUCTS_CATEGORIES',
};

export default ProductCategory;
